/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useStyles } from "../styles";

const ColoredCircles = () => {
  const { errorBoxDots } = useStyles();

  return (
    <div css={css(errorBoxDots)} data-testid="colored-circles">
      <span />
      <span />
      <span />
    </div>
  );
};

export default ColoredCircles;
